<div class="subscribe-section">
  <div class="content" *ngIf="showImage">
    <div class="text-right">
      <mat-icon mat-dialog-close class="close-button">close</mat-icon>
    </div>
    <h1>Stay Connected with the Meraki Team</h1>
    <p>Get exclusive updates, insights, and offers from the Meraki team!</p>

    <form
      [formGroup]="subscribeForm"
      (ngSubmit)="onSubmit()"
      class="subscribe-form"
    >
      <input
        class="form-control"
        type="email"
        formControlName="email"
        placeholder="Enter your email"
      />
      <button type="submit" [disabled]="subscribeForm.invalid">
        Request Now
      </button>
    </form>

    <p class="contact-info">
      Have questions? Contact us at: <strong>+91 85217 54134</strong>
    </p>
  </div>
  <div class="contentImg" *ngIf="!showImage && data.item.label === 'Port Consumption'" >
<img src="../../../assets/images/port_consumption.jpg" alt="" class="img">
  </div>
    <div class="contentImg" *ngIf="!showImage && data.item.label === 'Disbursement'">
<img src="../../../assets/images/port_consumption.jpg" alt="" class="img">
  </div>
</div>
